export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "Python + Data Science Level - 1 & 2",
  description: "Visual Intelligence with Python",
  about:
    "Learn to build intelligent systems that see and understand the world. This course covers image processing, object detection, and visual data analysis-transforming raw pixels into actionable insights for real-world computer vision applications.",
  skills: [
    "Object Detection",
    "Segmentation",
    "Facial Recognition",
    "Video Processing",
  ],
  reviews: {
    1: {
      name: "Elias Bowman",
      review:
        "This course offered an excellent introduction to Computer Vision. I loved how clearly image processing fundamentals were explained, especially histogram analysis and filtering techniques.",
    },
    2: {
      name: "Nayeli Cortez",
      review:
        "Very well-structured and practical. The instructor walked us through real-world applications like face detection and object tracking with ease. I enjoyed every module.",
    },
    3: {
      name: "Hugo Martins",
      review:
        "Computer Vision always felt intimidating, but this course broke everything down beautifully. I finally understand edge detection, thresholding, and feature extraction.",
    },
    4: {
      name: "Selena Brooks",
      review:
        "I absolutely loved the hands-on approach. Using OpenCV in real exercises made the concepts stick. This course made learning fun and impactful.",
    },
    5: {
      name: "Arjun Deshmukh",
      review:
        "The content was very practical and beginner-friendly. The instructor made sure every concept—from image matrices to contour detection—was taught clearly.",
    },
    6: {
      name: "Marisol Jiménez",
      review:
        "The course was engaging from start to finish. I enjoyed working with image filters and transformations. The demos were especially helpful.",
    },
    7: {
      name: "Theo Kaplan",
      review:
        "Wonderful introduction to Computer Vision techniques. I finally understand how object recognition works step-by-step. Great teaching style!",
    },
    8: {
      name: "Ivanna Petrova",
      review:
        "Super informative course! The breakdown of convolution and kernels was easy to follow. I also enjoyed the real-time camera-based experiments.",
    },
    9: {
      name: "David McPherson",
      review:
        "I liked how the instructor combined theory with coding. Learning about color spaces, image segmentation, and pattern detection was incredibly useful.",
    },
    10: {
      name: "Jasmine Liu",
      review:
        "The course simplified complex topics like HOG features and image gradients. The practical exercises helped me quickly apply the theory.",
    },
    11: {
      name: "Carter Vaughn",
      review:
        "A very hands-on and engaging course. I loved the pace and the clarity of each section. It’s perfect for anyone wanting to learn OpenCV basics.",
    },
    12: {
      name: "Mina El-Sayed",
      review:
        "Excellent content! The instructor explained computer vision pipelines beautifully, from reading images to detecting and tracking objects.",
    },
    13: {
      name: "Franco Duran",
      review:
        "This course made image processing feel easy to learn. I found the modules on feature detection and matching incredibly valuable.",
    },
    14: {
      name: "Talia Zane",
      review:
        "Super clear lessons with practical examples. The object detection and contour analysis sections were especially enjoyable to work through.",
    },
    15: {
      name: "Viktor Larsson",
      review:
        "The demonstrations in this course really helped. I liked experimenting with filters and transformations while following the instructor's explanations.",
    },
    16: {
      name: "Camila Andrade",
      review:
        "I finally understand how images are represented in arrays and how different operations affect them. The course was both fun and educational.",
    },
    17: {
      name: "Dennis Holloway",
      review:
        "Great course for beginners! The step-by-step walkthroughs of segmentation and feature extraction techniques made all the difference.",
    },
    18: {
      name: "Amina Diallo",
      review:
        "The content is absolutely beginner-friendly but still very insightful. Learning about object recognition and edge detection was fascinating.",
    },
    19: {
      name: "Johannes Becker",
      review:
        "I enjoyed how the course explained the intuition behind Computer Vision tasks. The examples were simple yet very effective for learning.",
    },
    20: {
      name: "Farah Ghani",
      review:
        "This course helped me understand image manipulation and pattern identification clearly. I loved the assignments—they were challenging but doable.",
    },
    21: {
      name: "Leon Stokes",
      review:
        "The instructor really knows how to simplify complicated ideas. The modules on OpenCV functions were super helpful and very well explained.",
    },
    22: {
      name: "Mariya Koval",
      review:
        "Great hands-on experience! I felt like I was actually building real Computer Vision applications rather than just learning theory.",
    },
    23: {
      name: "Abdul Rahman",
      review:
        "I never thought learning about image detection and filtering could be this fun. The course is perfect for both beginners and intermediate learners.",
    },
    24: {
      name: "Jolene Francis",
      review:
        "This course introduced me to the world of Computer Vision in the best way. Everything was clear, concise, and practical.",
    },
    25: {
      name: "Royce Newman",
      review:
        "A solid introduction to Computer Vision. The examples, coding sessions, and explanations were all top-notch. Definitely worth taking.",
    },
  },
  modules: {
    "Computer Vision Foundations": [
      "Applications of Computer Vision.",
      "Image formats, pixels, and color spaces.",
      "Reading, displaying, and saving images.",
      "Accessing and manipulating pixel data with NumPy.",
      "Draw shapes, lines, and text on images for marking objects and regions.",
    ],
    "Image Processing with OpenCV": [
      "Image Resizing & Cropping.",
      "Image Filtering & Smoothing.",
      "Edge Detection Techniques.",
      "Thresholding & Segmentation.",
      "Contour Detection & Shape Analysis.",
    ],
    "Deep Learning for Vision": [
      "Understanding CNNs.",
      "Build classification models from dataset preparation to prediction.",
      "Pre-trained CNN Architectures.",
      "Augmentation, Feature Extraction and Transfer Learning Techniques.",
      "Object Detection Basics.",
    ],
    "Object Detection & Video Processing": [
      "Face Detection and Emotion Recognition.",
      "Pre-trained Object Detection and Segmentation Models.",
      "Training Object Detection For Custom Datasets.",
      "Tracking Objects and Video Processing.",
      "Image to Text: Optical Character Recognition.",
      "Google Vision Apps (Mediapipe).",
    ],
    "Real-World Impact & Capstone Journey": [
      "Apply computer vision in real-world domains such as healthcare, autonomous systems, retail analytics, and security.",
      "Work on an end-to-end capstone project solving an image-based industry challenge.",
      "Build a project portfolio showcasing your expertise in image classification, object detection, and segmentation.",
    ],
  },
};
